module.exports = __webpack_public_path__ + "static/media/pythonLogo.d3c746b2.png";